import VerifiedIcon from './VerifiedIcon'

export default VerifiedIcon
